module.exports = __webpack_public_path__ + "img/200004.63c67978.png";